import { ref } from 'vue'

/**
 * Simple composable for managing modal visibility state
 *
 * @param initialState - Initial visibility state (default: false)
 * @returns Object with modal state and control methods
 */
export function useModal(initialState = false) {
  const isVisible = ref(initialState)

  function open(): void {
    isVisible.value = true
  }

  function close(): void {
    isVisible.value = false
  }

  function toggle(): void {
    isVisible.value = !isVisible.value
  }

  return {
    isVisible,
    open,
    close,
    toggle,
  }
}
